jQuery(function($){
    //test 
    console.log('ADA Scripts Added');

    $('footer.footer').attr('id','neso_footer');    
    $('sticky-header').find('header.header').attr('id','neso_header');

    //fix missing h1's
    var h1Cnt = 0;
    $('body').find('h1').each(function(){
        h1Cnt++;
    });
    if(h1Cnt === 0){
        $('body').prepend('<div role="region" aria-label="Page Heading"><h1 class="sr-only">'+($('title').html())+'</h1></div>');
    }

    //jdgm carousel
    var viewportWidth = window.innerWidth;
    var sizing = (viewportWidth*0.3333333)-37;
    sizing = sizing*(-1);
    console.log('Screen width: '+viewportWidth + ' 33% is: '+sizing);
    setTimeout(function(){
    var slideCnt = 0;
    $('.jdgm-widget').find('.jdgm-carousel-item').each(function(){
        var slideTitle = String($(this).find('.jdgm-carousel-item__product-title').text());
        var curImgAlt = String($(this).find('.jdgm-carousel-item__product-image').attr('alt'));
        if(!slideTitle || slideTitle === '' || slideTitle === 'undefined'){
            slideTitle = curImgAlt;
        }
        $(this).attr('epic-slide',slideCnt);
        $(this).parent().attr('epic-slide-tot',slideCnt);
        $(this).find('.jdgm-carousel-item__product-image').attr('alt',curImgAlt+' Product Image');
        $(this).find('.jdgm-carousel-item__full-review-link').attr('aria-label',slideTitle+' Review Link');
        slideCnt++;
    });
    $('.jdgm-widget').find('.jdgm-carousel-item').each(function(){
        var curSlide = parseInt($(this).attr('epic-slide'), 10);
        var curSlideTot = parseInt($(this).parent().attr('epic-slide-tot'));
        console.log('Slide: '+curSlide + ' ' + curSlideTot);
        $(this).find('.jdgm-carousel-item__full-review-link').on('keydown', function(e){
            if(e.key === 'Tab'){
                console.log('Tab pressed ' + (sizing*curSlide));
                if(curSlide < curSlideTot){
                    $(this).parent().parent().css('transform', 'translate3d('+(sizing*curSlide)+'px,0px,0px)');
                }
            }
        });

    });
    },1800);

    //Secondary Mega Menu
    $('nav[aria-label="Mega Menu navigation"]').find('.mega-menu').each(function(){
        var currentAria = String($(this).attr('aria-controls'));
        $(this).attr('aria-controls',currentAria+'_sec');
        $(this).find('.mega-menu__content').attr('id',currentAria+'_sec');
    });

    /* Videos */
    var angle_icon = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 17" height="26" width="26">'+
                     '<path fill="#0F0F0F" d="M2.86383 6.02935C2.92575 5.96727 2.99932 5.91801 3.08032 5.8844C3.16131 5.8508 3.24814 5.8335 3.33583 5.8335C3.42352 5.8335 3.51035 5.8508 3.59134 5.8844C3.67233 5.91801 3.7459 5.96727 3.80783 6.02935L8.00249 10.2254L12.1972 6.02935C12.3223 5.90417 12.4921 5.83385 12.6692 5.83385C12.8462 5.83385 13.016 5.90417 13.1412 6.02935C13.2663 6.15454 13.3367 6.32432 13.3367 6.50135C13.3367 6.67839 13.2663 6.84817 13.1412 6.97335L8.47449 11.64C8.41257 11.7021 8.339 11.7514 8.25801 11.785C8.17701 11.8186 8.09018 11.8359 8.00249 11.8359C7.9148 11.8359 7.82798 11.8186 7.74698 11.785C7.66599 11.7514 7.59242 11.7021 7.53049 11.64L2.86383 6.97335C2.80174 6.91143 2.75249 6.83786 2.71888 6.75687C2.68527 6.67587 2.66797 6.58904 2.66797 6.50135C2.66797 6.41366 2.68527 6.32684 2.71888 6.24584C2.75249 6.16485 2.80174 6.09128 2.86383 6.02935Z"></path>'+
                     '</svg>';
    // wrapper
    var transcript_wrapper_1 = '<div class="video-transcript-1"><details class="trans">'+
	      '<summary class="transBtn">Transcript <span class="icon" aria-hidden="true">'+angle_icon+'</span></summary>'+
	      ' <div class="transCntntWrap">'+
		  '   <div class="h5" role="heading" aria-level="3">Descriptive Video Transcript</div>'; 
    var transcript_title_1 = '<h4 class="h5">';
    var transcript_title_home = 'NESO Tent';
    var transcript_title_1_close = '</h4>'+
          '   <p>[Video Start]<br>[English]</p>';
    var transcript_content_home = '<p>Family of 3 having a fun beach day showing how easy it is to stay protected from the sun under a Neso tent.</p>';
    var transcript_wrapper_1_close = '   <p>[Video End]</p>'+
	        ' </div>'+
          '</details>';
    var vidCnt = 0;
    $('#videoContainer').find('.js-video-button').each(function(){
        var getId = String($(this).attr('data-video-id'));
        var getTitle = String($(this).attr('title'));
        var getDesc = String($(this).attr('aria-describedby'));
        var curTitle = '';
        var curDescription = '';
        if(getId.indexOf('405208793') > -1){
            curTitle = 'NESO Tent Introduction';
            curDescription = 'A man takes his Neso Grande beach shade to the beach to setup for his family to enjoy the day while he surfs. It shows how portable our products are.';
        } else if(getId.indexOf('586155010') > -1){
            curTitle = 'Introducing NESO Party Tent';
            curDescription = 'A large group of people setup a Neso Party tent on the grass to host a yoga practice underneath. Afterwards, they move to the party to the sand for a sunset hang.';
        }
        else if(getId.indexOf('405530625') > -1){
            curTitle = 'Off the Beach';
            curDescription = 'The sidelines tent is a versatile sunshade for various applications. A family takes the Neso Sidelines tent from a soccer game, to a hike with some bouldering, then followed by a vanlife sunset hang.';
        }else if(getId.indexOf('405214090') > -1){
            curTitle = 'Ohana Time';
            curDescription = 'A family in Hawaii shows how easy it is to setup a Neso Grande tent for a beach day while their son surfs.';
        }else if(getId.indexOf('405210453') > -1){
            curTitle = 'The NESO Chair';
            curDescription = 'A couple throw their compact Neso chairs in the car for an impromptu beach hang.';
        }else if(getId.indexOf('405211543') > -1){
            curTitle = 'Sunny Daze';
            curDescription = 'Two girls take their Neso 1 sunshade to the beach for a fun surf session.';
        }
        else if(getId.indexOf('882660989') > -1){
            curTitle = 'More Windy Day Tips';
            curDescription = 'A man shows specific steps to take to keep your Neso beach tent standing strong on a windy day.';
        }else if(getId.indexOf('405224017') > -1){
            curTitle = 'Setup Instructions';
            curDescription = 'General assembly instructions on how to setup a Neso beach tent. A woman shows a step-by-step guide on how to setup a Neso beach tent.';
        }else if(getId.indexOf('446973703') > -1){
            curTitle = 'Windy Day Tips';
            curDescription = 'A woman explains specific tips and suggestions to fix a floppy Neso beach tent.';
        }else if(getId.indexOf('590052350') > -1){
            curTitle = 'Party Tent Instructional Video';
            curDescription = 'General assembly instructions on how to setup a Neso party tent on grass. A woman shows a step-by-step guide on how to setup a Neso party tent on grass.';
        }else if(getId.indexOf('644065141') > -1){
            curTitle = 'Sidelines Tent Instructional Video';
            curDescription = 'General assembly instructions on how to setup a Neso Sidelines tent on grass. A man shows a step-by-step guide on how to setup a Neso Sidelines tent.';
        } else if(getId.indexOf('644064782') > -1){
            curTitle = 'Sidelines Conversion Kit';
            curDescription = 'If you\'d like to take your beach tent off the beach, this video explains how to switch out the sand bags for our off the beach Sidelines conversion kit.';
        } else if(getId.indexOf('405226456') > -1){
            curTitle = 'Tips for Windy Conditions';
            curDescription = 'Tips on how to setup a Neso beach tent in windy conditions. A man offers some tips on how to make sure your Neso tent stands strong on a windy day.';
        }  else if(getId.indexOf('851759762') > -1){
            curTitle = 'More Tips for Windy Conditions';
            curDescription = 'A man shows specific steps to take to keep your Neso beach tent standing strong on a windy day.';
        }  else if(getId.indexOf('1108750894') > -1){
            curTitle = 'More Tips for Windy Conditions';
            curDescription = 'A real customer explains how he setup his Neso beach shade on a windy day in North Carolina.';
        }  
        else if(getId.indexOf('692411707') > -1){
            curTitle = 'NESO Beach Table';
            curDescription = 'A man and woman play cards on the Neso beach table while utilizing the cup holds for drinks and cell phone holders demonstrating the features.';
        } else if(getId.indexOf('432585365') > -1){
            curTitle = 'NESO Beach Tote';
            curDescription = 'A woman explains and demonstrates  the features of the Neso beach tote. ';
        } 
        else {
            curTitle = 'Vimeo Video';
            curDescription = 'Vimeo Description';
        }
        $(this).attr('tabindex','0').attr('role','button').attr('type','button');
        $(this).on('keydown', function(e){
            if(e.key === 'Enter'){
                $(this).click();
                keyboardEscape();                
            }
        });
        if(!getTitle || getTitle === '' || getTitle === 'undefined'){
            $(this).attr('title', curTitle).attr('aria-label',curTitle);
        } else {
            $(this).attr('aria-label', getTitle);
        }
        if(!getDesc || getDesc === '' || getDesc === 'undefined'){
            $(this).attr('aria-describedby','desc_'+vidCnt);
            $(this).parent().append('<span id="desc_'+vidCnt+'" class="sr-only">'+curDescription+'</span>');
        }
        vidCnt++;
    });

    //homepage video 2bbc343c9aa7426da530f917d8825d1d.mp4 (desktop version)
    //<track label="English" kind="captions" srclang="en" src="file type vtt" default />
    $('.custom-video-section').each(function(){
        $(this).find('video').each(function(){
            var curSrc = String($(this).find('source').attr('src'));
            if(curSrc.indexOf('2bbc343c9aa7426da530f917d8825d1d.mp4') > -1){
                //update both the desktop and mobile video
                var vttUrl = "//www.neso.com/cdn/shop/t/47/assets/HomePage-Neso-Video_no-audio.vtt?v=128563155808467680971778678077";
                var homepage_trans = transcript_wrapper_1 + transcript_title_1 + transcript_title_home + transcript_title_1_close +
                                     transcript_content_home + transcript_wrapper_1_close;
                $(this).parent().parent().find('video').each(function(){
                    $(this).append('<track label="English" kind="captions" srclang="en" src="'+vttUrl+'" default />');
                });
                $(this).parent().parent().append(homepage_trans);
            }
        });
    });
    $('.video-section__media').each(function(){        
        var getId = String($(this).attr('data-media-id'));
        var curTitle = '';
        var curDescription = '';
        transcript_wrapper_1 = '<div class="video-transcript-1"><details class="trans">'+
	      '<summary class="transBtn">Transcript <span class="icon" aria-hidden="true">'+angle_icon+'</span></summary>'+
	      ' <div class="transCntntWrap">'+
		  '   <div class="h5" role="heading" aria-level="2">Descriptive Video Transcript</div>'; 
        transcript_title_1 = '<h3 class="h5">';
        
        transcript_title_1_close = '</h3>'+
        '   <p>[Video Start]<br>[English]</p>';
        if(getId.indexOf('405208793') > -1){
            curTitle = 'NESO Tent Introduction';
            curDescription = 'A man takes his Neso Grande beach shade to the beach to setup for his family to enjoy the day while he surfs. It shows how portable our products are.';
        } else if(getId.indexOf('586155010') > -1){
            curTitle = 'Introducing NESO Party Tent';
            curDescription = 'A large group of people setup a Neso Party tent on the grass to host a yoga practice underneath. Afterwards, they move to the party to the sand for a sunset hang.';
        }
        else if(getId.indexOf('405530625') > -1){
            curTitle = 'Off the Beach';
            curDescription = 'The sidelines tent is a versatile sunshade for various applications. A family takes the Neso Sidelines tent from a soccer game, to a hike with some bouldering, then followed by a vanlife sunset hang.';
        }else if(getId.indexOf('405214090') > -1){
            curTitle = 'Ohana Time';
            curDescription = 'A family in Hawaii shows how easy it is to setup a Neso Grande tent for a beach day while their son surfs.';
        }else if(getId.indexOf('405210453') > -1){
            curTitle = 'The NESO Chair';
            curDescription = 'A couple throw their compact Neso chairs in the car for an impromptu beach hang.';
        }else if(getId.indexOf('405211543') > -1){
            curTitle = 'Sunny Daze';
            curDescription = 'Two girls take their Neso 1 sunshade to the beach for a fun surf session.';
        }
        else if(getId.indexOf('882660989') > -1){
            curTitle = 'More Windy Day Tips';
            curDescription = 'A man shows specific steps to take to keep your Neso beach tent standing strong on a windy day.';
        }else if(getId.indexOf('405224017') > -1){
            curTitle = 'Setup Instructions';
            curDescription = 'General assembly instructions on how to setup a Neso beach tent. A woman shows a step-by-step guide on how to setup a Neso beach tent.';
        }else if(getId.indexOf('446973703') > -1){
            curTitle = 'Windy Day Tips';
            curDescription = 'A woman explains specific tips and suggestions to fix a floppy Neso beach tent.';
        }else if(getId.indexOf('590052350') > -1){
            curTitle = 'Party Tent Instructional Video';
            curDescription = 'General assembly instructions on how to setup a Neso party tent on grass. A woman shows a step-by-step guide on how to setup a Neso party tent on grass.';
        }else if(getId.indexOf('644065141') > -1){
            curTitle = 'Sidelines Tent Instructional Video';
            curDescription = 'General assembly instructions on how to setup a Neso Sidelines tent on grass. A man shows a step-by-step guide on how to setup a Neso Sidelines tent.';
        } else if(getId.indexOf('644064782') > -1){
            curTitle = 'Sidelines Conversion Kit';
            curDescription = 'If you\'d like to take your beach tent off the beach, this video explains how to switch out the sand bags for our off the beach Sidelines conversion kit.';
        } else if(getId.indexOf('405226456') > -1){
            curTitle = 'Tips for Windy Conditions';
            curDescription = 'Tips on how to setup a Neso beach tent in windy conditions. A man offers some tips on how to make sure your Neso tent stands strong on a windy day.';
        }  else if(getId.indexOf('851759762') > -1){
            curTitle = 'More Tips for Windy Conditions';
            curDescription = 'A man shows specific steps to take to keep your Neso beach tent standing strong on a windy day.';
        }  else if(getId.indexOf('1108750894') > -1){
            curTitle = 'More Tips for Windy Conditions';
            curDescription = 'A real customer explains how he setup his Neso beach shade on a windy day in North Carolina.';
        }  
        else if(getId.indexOf('692411707') > -1){
            curTitle = 'NESO Beach Table';
            curDescription = 'A man and woman play cards on the Neso beach table while utilizing the cup holds for drinks and cell phone holders demonstrating the features.';
        } else if(getId.indexOf('432585365') > -1){
            curTitle = 'NESO Beach Tote';
            curDescription = 'A woman explains and demonstrates  the features of the Neso beach tote. ';
        } //_9VUPq3SxOc
        else if(getId.indexOf('_9VUPq3SxOc') > -1){
            curTitle = 'Party Tent Setup';
            curDescription = 'You Tube Video - Music Playing';
        }
        else {
            curTitle = 'Vimeo Video';
            curDescription = 'Vimeo Description';
        }
        var homepage_trans = transcript_wrapper_1 + transcript_title_1 + curTitle + transcript_title_1_close +
                                     curDescription + transcript_wrapper_1_close;
        $(this).parent().append(homepage_trans);
    });

    //product pages
    $('.product-media-container.media-type-external_video').each(function(){
        var getId = String($(this).find('.deferred-media').attr('data-media-id'));
        var curTitle = '';
        var curDescription = '';
        transcript_wrapper_1 = '<div class="video-transcript-1"><details class="trans">'+
	      '<summary class="transBtn">Transcript <span class="icon" aria-hidden="true">'+angle_icon+'</span></summary>'+
	      ' <div class="transCntntWrap">'+
		  '   <div class="h5" role="heading" aria-level="2">Descriptive Video Transcript</div>'; 
        transcript_title_1 = '<h3 class="h5">';
        
        transcript_title_1_close = '</h3>'+
        '   <p>[Video Start]<br>[English]</p>';
        if(getId.indexOf('405208793') > -1){
            curTitle = 'NESO Tent Introduction';
            curDescription = 'A man takes his Neso Grande beach shade to the beach to setup for his family to enjoy the day while he surfs. It shows how portable our products are.';
        } else if(getId.indexOf('586155010') > -1){
            curTitle = 'Introducing NESO Party Tent';
            curDescription = 'A large group of people setup a Neso Party tent on the grass to host a yoga practice underneath. Afterwards, they move to the party to the sand for a sunset hang.';
        }
        else if(getId.indexOf('405530625') > -1){
            curTitle = 'Off the Beach';
            curDescription = 'The sidelines tent is a versatile sunshade for various applications. A family takes the Neso Sidelines tent from a soccer game, to a hike with some bouldering, then followed by a vanlife sunset hang.';
        }else if(getId.indexOf('405214090') > -1 || getId.indexOf('34603101847861') > -1 || getId.indexOf('34603239244085') > -1){
            curTitle = 'Ohana Time';
            curDescription = 'A family in Hawaii shows how easy it is to setup a Neso Grande tent for a beach day while their son surfs.';
        }else if(getId.indexOf('405210453') > -1 || getId.indexOf('34603202314549') > -1){
            curTitle = 'The NESO Chair';
            curDescription = 'A couple throw their compact Neso chairs in the car for an impromptu beach hang.';
        }else if(getId.indexOf('405211543') > -1 || getId.indexOf('34601962373429') > -1){
            curTitle = 'Sunny Daze';
            curDescription = 'Two girls take their Neso 1 sunshade to the beach for a fun surf session.';
        }
        else if(getId.indexOf('882660989') > -1){
            curTitle = 'More Windy Day Tips';
            curDescription = 'A man shows specific steps to take to keep your Neso beach tent standing strong on a windy day.';
        }else if(getId.indexOf('405224017') > -1){
            curTitle = 'Setup Instructions';
            curDescription = 'General assembly instructions on how to setup a Neso beach tent. A woman shows a step-by-step guide on how to setup a Neso beach tent.';
        }else if(getId.indexOf('446973703') > -1){
            curTitle = 'Windy Day Tips';
            curDescription = 'A woman explains specific tips and suggestions to fix a floppy Neso beach tent.';
        }else if(getId.indexOf('590052350') > -1){
            curTitle = 'Party Tent Instructional Video';
            curDescription = 'General assembly instructions on how to setup a Neso party tent on grass. A woman shows a step-by-step guide on how to setup a Neso party tent on grass.';
        }else if(getId.indexOf('644065141') > -1){
            curTitle = 'Sidelines Tent Instructional Video';
            curDescription = 'General assembly instructions on how to setup a Neso Sidelines tent on grass. A man shows a step-by-step guide on how to setup a Neso Sidelines tent.';
        } else if(getId.indexOf('644064782') > -1){
            curTitle = 'Sidelines Conversion Kit';
            curDescription = 'If you\'d like to take your beach tent off the beach, this video explains how to switch out the sand bags for our off the beach Sidelines conversion kit.';
        } else if(getId.indexOf('405226456') > -1){
            curTitle = 'Tips for Windy Conditions';
            curDescription = 'Tips on how to setup a Neso beach tent in windy conditions. A man offers some tips on how to make sure your Neso tent stands strong on a windy day.';
        }  else if(getId.indexOf('851759762') > -1){
            curTitle = 'More Tips for Windy Conditions';
            curDescription = 'A man shows specific steps to take to keep your Neso beach tent standing strong on a windy day.';
        }  else if(getId.indexOf('1108750894') > -1){
            curTitle = 'More Tips for Windy Conditions';
            curDescription = 'A real customer explains how he setup his Neso beach shade on a windy day in North Carolina.';
        }  
        else if(getId.indexOf('692411707') > -1 || getId.indexOf('34603229020469') > -1){
            curTitle = 'NESO Beach Table';
            curDescription = 'A man and woman play cards on the Neso beach table while utilizing the cup holds for drinks and cell phone holders demonstrating the features.';
        } else if(getId.indexOf('432585365') > -1 || getId.indexOf('34603215487285') > -1){
            curTitle = 'NESO Beach Tote';
            curDescription = 'A woman explains and demonstrates  the features of the Neso beach tote. ';
        } else if(getId.indexOf('34603170201909') > -1 || getId.indexOf('34603179639093') > -1){
            curTitle = 'Sidelines 1';
            curDescription = 'The sidelines tent is a versatile sunshade for various applications. A family takes the Neso Sidelines tent from a soccer game, to a hike with some bouldering, then followed by a vanlife sunset hang.';
        } 
        else {
            curTitle = 'Vimeo Video';
            curDescription = 'Vimeo Description';
        }
        var homepage_trans = transcript_wrapper_1 + transcript_title_1 + curTitle + transcript_title_1_close +
                                     curDescription + transcript_wrapper_1_close;
        $(this).append(homepage_trans);
    });

    //Collection pages
    var pCnt = 0;
    setTimeout(function(){
    $('#ProductGridContainer').find('.grid__item').each(function(){
        $(this).attr('ep-prod',pCnt);
        //collection grid
        var productTitle = String($(this).find('h2').find('a').html());
        productTitle = productTitle.trim();
        $(this).find('.product-metafield__features').each(function(){
            $(this).attr('role','tree').attr('aria-label','Features for '+productTitle);
            $(this).find('li').each(function(){
                $(this).attr('role','treeitem');
            });
        });
        $(this).find('.color-swatches__product').each(function(){
            $(this).attr('role','group').attr('aria-label','Available Colors for '+productTitle);
        });
        pCnt++;
    });
    }, 2000);

    /* product pages */
    $('.product').find('.product__info-wrapper').each(function(){
        //setup anchor
        $(this).prepend('<a name="product-anchor" class="sr-only sr-only-focusable" tabindex="0">Product:</a>');
    });

    //image links
    $('a[href]').each(function(){
        var curHtml = String($(this).html());
        if(curHtml.indexOf('<img') > -1){
            $(this).addClass('img-link');
        }
    });
/* Resolve WAVE Flags if possible */

$('.top-tents__box').css('background-color','#000000').css('color','#FFFFFF');
$('#hero-section').css('background-color','#FFFFFF').css('color','#000000');
$('#MegaMenu-Content-1').find('.child-main__inner-wrapper').each(function(){
    $(this).find('.child-menu-item__collection').each(function(){
        $(this).find('.mega-menu__link').css('background-color','#000000').css('color','#FFFFFF');
    });
});
$('header-menu').find('.mega-menu__list').each(function(){
    $(this).find('> div').each(function(){
        $(this).attr('role','listitem');
    });
    $(this).find('.child-main__inner-wrapper').each(function(){
        $(this).find('.mega-menu__link').each(function(){
            var curHtml = String($(this).html());
            curHtml = curHtml.trim();
            if(curHtml === ''){
                $(this).remove();
            }
        });
    });
});
$('header-menu').find('.mega-menu__list--condensed').each(function(){
    $(this).removeAttr('role');
    $(this).find('.inner-mega-menu_____grid').attr('role','list');
    $(this).find('.inner-mega-menu_____grid').find('> div').each(function(){
        $(this).attr('role','listitem');
    });
});
$('.web-icon').find('svg').each(function(){
    $(this).attr('aria-hidden','true');   
});
$('.web-icon').find('span').append('<span class="sr-only">Dropdown arrow</span>');
$('.menu-drawer__utility-links').find('svg').each(function(){
    $(this).attr('aria-hidden','true');   
});
$('.menu-drawer__utility-links').find('.region___wrapper').each(function(){
    $(this).find('button').attr('aria-label','language toggle');
    $(this).find('select').attr('aria-label','language options');
});

//unneeded aria-labelledby's incorrectly marked up
$('.product-grid-container').each(function(){
   // $(this).attr('epic','test1');
    $(this).find('.product-grid').each(function(){
      //  $(this).attr('epic','test2');
        $(this).find('.grid__item').each(function(){
         //   $(this).attr('epic','test3');
            $(this).find('.card').each(function(){
            //    $(this).attr('epic','test4');
                $(this).find('.card__heading').each(function(){
              //      $(this).attr('epic','test5');
                    $(this).find('a[href]').each(function(){
                        $(this).removeAttr('aria-labelledby');
                    });
                });
            });
        });
    });
});
setTimeout(function(){
$('.complementary-products').each(function(){
    //$(this).attr('epic','test1');
    
    $(this).find('[aria-label="Complementary products"]').each(function(){
       // $(this).attr('epic','test2');
        $(this).find('.complementary-products__container').each(function(){
            //$(this).attr('epic','test3');
            $(this).find('.card').each(function(){
               // $(this).attr('epic','test4');
                $(this).find('.card__heading').each(function(){
                    $(this).attr('epic','test5');
                    $(this).find('a[href]').each(function(){
                        $(this).removeAttr('aria-labelledby');
                    });
                });
            });
        });
    });
    
});

$('.thumbnail-list').each(function(){
    $(this).find('li').each(function(){
        $(this).attr('epic','test');
        $(this).find('button[aria-label]').each(function(){
            $(this).attr('epic','removeDesc');
            $(this).removeAttr('aria-describedby');
        });
    });
});
},1500);

// add listener for vimeo modal opening
function keyboardEscape(){
    $('.modal-video').each(function(){
        $(this).on('keydown', function(e){
            if(e.key === 'Escape'){
                $(this).find('.modal-video-close-btn').click();
            }
        });
    });
}


});